import { DateTimeProps } from 'components/DateTime/Types'
import dayjs from 'dayjs'

export const defaultDateTimeFormat = 'h:mma'

export const DateTime = ({ timestamp, format = defaultDateTimeFormat }: DateTimeProps) => (
  <>{dayjs(timestamp).format(format)}</>
)
